import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import queries from "../queries";
import Swal from "sweetalert2";
import { isMobileScreen } from "../common";

function Footer(props) {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const [subscribeToNewsletter] = useMutation(
    queries.newsletter.SUBSCRIBE_TO_NEWSLETTER
  );

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleSubscribe = async (e) => {
    e.preventDefault();

    if (!email || email.trim() === "") {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Please enter your email address",
      });
      return;
    }

    if (!validateEmail(email)) {
      Swal.fire({
        icon: "error",
        title: "Invalid Email",
        text: "Please enter a valid email address",
      });
      return;
    }

    setIsSubmitting(true);

    try {
      const { data } = await subscribeToNewsletter({
        variables: { email: email.trim().toLowerCase() },
      });

      if (data?.subscribeToNewsletter?.success) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text:
            data.subscribeToNewsletter.message ||
            "Successfully subscribed to our newsletter!",
          confirmButtonColor: "#28a745",
        });
        setEmail("");
      } else {
        throw new Error(
          data?.subscribeToNewsletter?.message || "Subscription failed"
        );
      }
    } catch (error) {
      console.error("Newsletter subscription error:", error);
      Swal.fire({
        icon: "error",
        title: "Subscription Failed",
        text:
          error.message ||
          "Unable to subscribe at this time. Please try again later.",
      });
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <footer
      className={
        isMobileScreen()
          ? "footer section-lg bg-dark mt-5"
          : "footer section-lg bg-dark"
      }
    >
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="row row-40">
              <div className="col-xl-5 col-lg-5 col-md-6">
                <h4 className="footer-title">Subscribe to Our Newsletter</h4>
                <form
                  className="rd-form rd-mailform form-sm"
                  data-form-type="subscribe"
                  onSubmit={handleSubscribe}
                >
                  <div className="rd-form-inline">
                    <div className="form-wrap">
                      <input
                        className="form-input"
                        id="subscribe-form-email"
                        type="email"
                        name="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        disabled={isSubmitting}
                        data-constraints="@Email @Required"
                      />
                      <label
                        className="form-label"
                        htmlFor="subscribe-form-email"
                      >
                        ENTER YOUR EMAIL
                      </label>
                    </div>
                    <div className="form-button">
                      <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Subscribing..." : "Subscribe"}
                      </button>
                    </div>
                  </div>
                  <div className="form-wrap">
                    <label className="shop-checkbox-wrap">
                      <span className="shop-checkbox-label">
                        * Your data will not be transferred to third parties.
                      </span>
                    </label>
                  </div>
                </form>
              </div>
              <div className="col-lg-2 col-md-3 col-sm-4 col-6 offset-xl-1">
                <h4 className="footer-title">Information</h4>
                <ul className="footer-list">
                  <li className="footer-list-item">
                    <a className="footer-link" href="/return-policy">
                      Return Policy
                    </a>
                  </li>
                  <li className="footer-list-item">
                    <a className="footer-link" href="/shipping-policy">
                      Shipping Policy
                    </a>
                  </li>
                  <li className="footer-list-item">
                    <a className="footer-link" href="/privacy-policy">
                      Privacy Policy
                    </a>
                  </li>
                  <li className="footer-list-item">
                    <a className="footer-link" href="/terms-and-conditions">
                      Terms & Conditions
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-4">
                <h4 className="footer-title">Contact Us</h4>
                <ul className="footer-list">
                  <li className="footer-list-item">Hours M-F: 9am-7pm EST</li>
                  <li className="footer-list-item">
                    <a className="footer-link-tel" href="tel:7813538922">
                      +1 (781) 353-8922
                    </a>
                  </li>
                  <li className="footer-list-item">
                    <a
                      className="footer-link"
                      href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL}`}
                    >
                      {process.env.REACT_APP_SUPPORT_EMAIL}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <hr />
        <div className="row">
          <div className="col-12">
            <div className="row row-15 align-items-center">
              <div className="col-lg-6 text-center text-lg-left">
                <a className="brand" href="index.html">
                  <img src="/images/logo.svg" alt="" width="104" height="22" />
                </a>
              </div>
              <div className="col-lg-6 text-center text-lg-right">
                <p className="rights">
                  <span>&copy;&nbsp;</span>
                  <span className="copyright-year"></span>
                  <span>&nbsp;</span>
                  <span>Roxxe</span>
                  <span>. All rights reserved</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
